import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import notify, { notificar } from '../utils/notify';
import '../styles/fechamentoernedu.css';
import '../styles/fmp.css';

const Fechamento_cliente = () => {
  const { cliente_id } = useParams(); // Pega ID da URL
  const navigate = useNavigate();
  
  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState({ tipo: '', texto: '' });
  useEffect(() => {
    if (!mensagem.texto) return;
    if (mensagem.tipo === 'success') notify.sucesso(mensagem.texto);
    else if (mensagem.tipo === 'warning') notify.aviso(mensagem.texto);
    else if (mensagem.tipo === 'danger') notify.erro(mensagem.texto);
    else notificar(mensagem.texto);
  }, [mensagem]);
  const [dadosCliente, setDadosCliente] = useState(null);
  const [abaAtiva, setAbaAtiva] = useState('fechamento');
  const [historico, setHistorico] = useState([]);
  const [carregandoHistorico, setCarregandoHistorico] = useState(false);
  
  const [checklistItems, setChecklistItems] = useState([]);
  const [carregandoChecklist, setCarregandoChecklist] = useState(false);
  const [novoItemLabel, setNovoItemLabel] = useState('');
  const [adicionandoItem, setAdicionandoItem] = useState(false);

  // Prévia do e-mail + confirmação antes de enviar
  const [mostrarConfirmacao, setMostrarConfirmacao] = useState(false);
  const [carregandoPreview, setCarregandoPreview] = useState(false);
  const [previewHtml, setPreviewHtml] = useState('');
  const [previewAssunto, setPreviewAssunto] = useState('');
  const [previewDest, setPreviewDest] = useState('');
  const [confirmacaoMarcada, setConfirmacaoMarcada] = useState(false);
  
  const [formData, setFormData] = useState({
    mes_referencia: '',
    link_pasta_drive: '',
    pendencias: ''
  });

  const [checklist, setChecklist] = useState({});

  useEffect(() => {
    carregarDadosCliente();
    carregarChecklistItems();
  }, []);

  useEffect(() => {
    if (abaAtiva === 'historico' && dadosCliente) {
      carregarHistorico();
    }
  }, [abaAtiva, dadosCliente]);

  const carregarChecklistItems = async () => {
    setCarregandoChecklist(true);
    try {
      const token = localStorage.getItem('access');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/checklist-items-cliente/`,
        {
          params: { cliente_id: cliente_id }, // Envia cliente_id
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );
      
      if (response.data.success) {
        const items = response.data.dados;
        setChecklistItems(items);
        
        const checklistInicial = {};
        items.forEach(item => {
          checklistInicial[item.item_key] = false;
        });
        setChecklist(checklistInicial);
        
        console.log('Checklist carregado:', items.length, 'itens');
      }
    } catch (error) {
      console.error('Erro ao carregar checklist:', error);
      mostrarMensagem('danger', 'Erro ao carregar itens do checklist');
    } finally {
      setCarregandoChecklist(false);
    }
  };

  const adicionarNovoItem = async () => {
    if (!novoItemLabel.trim()) {
      mostrarMensagem('warning', 'Digite o nome do item');
      return;
    }

    setAdicionandoItem(true);
    try {
      const token = localStorage.getItem('access');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/checklist-items-cliente/adicionar/`,
        { 
          cliente_id: cliente_id, // Envia cliente_id
          item_label: novoItemLabel 
        },
        {
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (response.data.success) {
        mostrarMensagem('success', 'Item adicionado com sucesso!');
        setNovoItemLabel('');
        carregarChecklistItems();
      } else {
        mostrarMensagem('danger', response.data.mensagem || 'Erro ao adicionar item');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.mensagem || 'Erro ao adicionar item';
      mostrarMensagem('danger', errorMsg);
    } finally {
      setAdicionandoItem(false);
    }
  };

  const removerItem = async (itemId, itemLabel) => {
    const confirmar = window.confirm(
      `Tem certeza que deseja remover o item "${itemLabel}"?\n\n` +
      `Esta ação não poderá ser desfeita.`
    );
    
    if (!confirmar) return;

    try {
      const token = localStorage.getItem('access');
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE}/api/checklist-items-cliente/${itemId}/remover/?cliente_id=${cliente_id}`, // Envia cliente_id
        {
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );
      
      if (response.data.success) {
        mostrarMensagem('success', 'Item removido com sucesso!');
        carregarChecklistItems();
      } else {
        mostrarMensagem('danger', response.data.mensagem || 'Erro ao remover item');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.mensagem || 'Erro ao remover item';
      mostrarMensagem('danger', errorMsg);
    }
  };

  const carregarDadosCliente = async () => {
    try {
      const token = localStorage.getItem('access');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/clientes-bpo/`,
        {
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );
      
      if (response.data.success) {
        const cliente = response.data.dados.find(c => c.id === parseInt(cliente_id));
        
        if (cliente) {
          setDadosCliente(cliente);
        }
      }
    } catch (error) {
      console.error('Erro ao carregar dados do cliente:', error);
    }
  };

  const carregarHistorico = async () => {
    if (!dadosCliente) return;
    
    setCarregandoHistorico(true);
    try {
      const token = localStorage.getItem('access');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/historico-fechamento-cliente/`,
        {
          params: { cliente_id: cliente_id }, // Envia cliente_id
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );
      
      if (response.data.success) {
        setHistorico(response.data.dados);
      }
    } catch (error) {
      console.error('Erro ao carregar histórico:', error);
      mostrarMensagem('danger', 'Erro ao carregar histórico de fechamentos');
    } finally {
      setCarregandoHistorico(false);
    }
  };

  const mostrarMensagem = (tipo, texto) => {
    setMensagem({ tipo, texto });
    setTimeout(() => setMensagem({ tipo: '', texto: '' }), 8000);
  };

  const handleChecklistChange = (item) => {
    setChecklist(prev => ({
      ...prev,
      [item]: !prev[item]
    }));
  };

  const marcarTodos = () => {
    const todosTrue = Object.keys(checklist).every(key => checklist[key]);
    const novoValor = !todosTrue;
    
    const novoChecklist = {};
    Object.keys(checklist).forEach(key => {
      novoChecklist[key] = novoValor;
    });
    
    setChecklist(novoChecklist);
  };

  const getItensFaltantes = () => {
    return checklistItems
      .filter(item => !checklist[item.item_key])
      .map(item => item.item_label);
  };

  const getTotalMarcados = () => {
    return Object.values(checklist).filter(Boolean).length;
  };

  const validarFormulario = () => {
    if (!formData.mes_referencia) {
      mostrarMensagem('warning', 'Selecione o mês de referência');
      return false;
    }

    if (!formData.link_pasta_drive) {
      mostrarMensagem('warning', 'Informe o link da pasta do Google Drive');
      return false;
    }

    if (!formData.link_pasta_drive.includes('drive.google.com')) {
      mostrarMensagem('warning', 'O link informado não parece ser do Google Drive');
      return false;
    }

    const itensFaltantes = getItensFaltantes();
    
    if (itensFaltantes.length > 0) {
      const confirmar = window.confirm(
        `ATENÇÃO: Os seguintes itens não foram marcados como concluídos:\n\n` +
        `${itensFaltantes.map(item => `• ${item}`).join('\n')}\n\n` +
        `Deseja continuar mesmo assim?`
      );
      
      if (!confirmar) {
        return false;
      }
    }

    if (!dadosCliente?.email_contabilidade) {
      mostrarMensagem('danger', 'Email da contabilidade não cadastrado para este cliente. Atualize o cadastro primeiro.');
      return false;
    }

    return true;
  };

  // Valida o formulário e abre o modal com a PRÉVIA REAL do e-mail
  const abrirPreviewFechamento = async () => {
    if (!validarFormulario()) {
      return;
    }

    setPreviewHtml('');
    setPreviewAssunto('');
    setPreviewDest('');
    setConfirmacaoMarcada(false);
    setMostrarConfirmacao(true);
    setCarregandoPreview(true);

    try {
      const token = localStorage.getItem('access');
      const payload = {
        cliente_id: cliente_id,
        email_contabilidade: dadosCliente.email_contabilidade,
        mes_referencia: formData.mes_referencia,
        link_pasta_drive: formData.link_pasta_drive,
        pendencias: formData.pendencias,
        checklist: checklist,
        itens_faltantes: getItensFaltantes(),
        preview: true
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/enviar-fechamento-mensal-cliente/`,
        payload,
        {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
          timeout: 60000
        }
      );

      if (response.data.success) {
        setPreviewHtml(response.data.html || '');
        setPreviewAssunto(response.data.assunto || '');
        setPreviewDest((response.data.destinatarios || []).join(', '));
      } else {
        mostrarMensagem('danger', response.data.mensagem || response.data.error || 'Erro ao gerar prévia');
        setMostrarConfirmacao(false);
      }
    } catch (error) {
      console.error('Erro ao gerar prévia do fechamento:', error);
      mostrarMensagem('danger', 'Erro ao gerar a prévia do email');
      setMostrarConfirmacao(false);
    } finally {
      setCarregandoPreview(false);
    }
  };

  const enviarFechamento = async () => {
    setMostrarConfirmacao(false);
    setCarregando(true);

    try {
      const token = localStorage.getItem('access');
      
      const payload = {
        cliente_id: cliente_id, // Envia cliente_id
        email_contabilidade: dadosCliente.email_contabilidade,
        mes_referencia: formData.mes_referencia,
        link_pasta_drive: formData.link_pasta_drive,
        pendencias: formData.pendencias,
        checklist: checklist,
        itens_faltantes: getItensFaltantes()
      };

      console.log('ENVIANDO FECHAMENTO:');
      console.log('  - Cliente ID:', cliente_id);
      console.log('  - Mês:', formData.mes_referencia);
      console.log('  - Itens concluídos:', getTotalMarcados(), '/', checklistItems.length);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/enviar-fechamento-mensal-cliente/`,
        payload,
        {
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (response.data.success) {
        const msgSucesso = response.data.mensagem || 'Fechamento enviado com sucesso para a contabilidade!';
        mostrarMensagem('success', msgSucesso);

        setFormData({
          mes_referencia: '',
          link_pasta_drive: '',
          pendencias: ''
        });

        const checklistLimpo = {};
        checklistItems.forEach(item => {
          checklistLimpo[item.item_key] = false;
        });
        setChecklist(checklistLimpo);

        if (abaAtiva === 'historico') {
          carregarHistorico();
        }
      } else {
        const msgErro = response.data.mensagem || response.data.error || 'Erro ao enviar fechamento';
        mostrarMensagem('danger', msgErro);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.mensagem || error.response?.data?.error || error.message || 'Erro ao enviar fechamento';
      mostrarMensagem('danger', errorMsg);
    } finally {
      setCarregando(false);
    }
  };

  const gerarOpcoesMeses = () => {
    const meses = [];
    const hoje = new Date();
    
    for (let i = 0; i < 12; i++) {
      const data = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
      const valor = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
      const label = data.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
      meses.push({ valor, label: label.charAt(0).toUpperCase() + label.slice(1) });
    }
    
    return meses;
  };

  const formatarMesReferencia = (mesRef) => {
    if (!mesRef) return '-';
    const [ano, mes] = mesRef.split('-');
    const meses = {
      '01': 'Janeiro', '02': 'Fevereiro', '03': 'Março', '04': 'Abril',
      '05': 'Maio', '06': 'Junho', '07': 'Julho', '08': 'Agosto',
      '09': 'Setembro', '10': 'Outubro', '11': 'Novembro', '12': 'Dezembro'
    };
    return `${meses[mes] || mes}/${ano}`;
  };

  const totalItems = checklistItems.length;
  const progressoChecklist = totalItems > 0 ? (getTotalMarcados() / totalItems) * 100 : 0;

  const renderAbaConfiguracoes = () => (
    <div>
      <div className="alert alert-info mb-4">
        <i className="fas fa-info-circle me-2"></i>
        <strong>Gerenciar Checklist de Documentos</strong>
        <p className="mb-0 mt-2 small">
          Adicione ou remova itens do checklist conforme necessário. 
          As alterações serão aplicadas imediatamente aos novos fechamentos.
        </p>
      </div>

      <div className="card border-0 shadow-sm mb-4">
        <div className="card-header bg-primary text-white">
          <i className="fas fa-plus-circle me-2"></i>
          Adicionar Novo Item
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-9">
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder="Digite o nome do item (ex: Extrato Bancário Santander)"
                value={novoItemLabel}
                onChange={(e) => setNovoItemLabel(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    adicionarNovoItem();
                  }
                }}
                disabled={adicionandoItem}
              />
            </div>
            <div className="col-md-3">
              <button
                type="button"
                className="btn btn-primary btn-lg w-100"
                onClick={adicionarNovoItem}
                disabled={adicionandoItem || !novoItemLabel.trim()}
              >
                {adicionandoItem ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Adicionando...
                  </>
                ) : (
                  <>
                    <i className="fas fa-plus me-2"></i>
                    Adicionar
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm">
        <div className="card-header bg-light d-flex justify-content-between align-items-center">
          <div>
            <i className="fas fa-list me-2 text-primary"></i>
            <span className="fw-bold">Itens do Checklist</span>
          </div>
          <span className="badge bg-primary">{checklistItems.length} itens</span>
        </div>
        <div className="card-body p-0">
          {carregandoChecklist ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Carregando...</span>
              </div>
              <p className="mt-3 text-muted">Carregando itens...</p>
            </div>
          ) : checklistItems.length === 0 ? (
            <div className="text-center py-5">
              <i className="fas fa-inbox fa-4x text-muted mb-3"></i>
              <h5 className="text-muted">Nenhum item cadastrado</h5>
              <p className="text-muted">Adicione o primeiro item ao checklist acima.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '80px' }} className="text-center">Ordem</th>
                    <th>Nome do Item</th>
                    <th style={{ width: '100px' }} className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {checklistItems.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-center">
                        <span className="badge bg-secondary">{index + 1}</span>
                      </td>
                      <td>
                        <i className="fas fa-check-square me-2 text-success"></i>
                        {item.item_label}
                      </td>
                      <td className="text-center">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removerItem(item.id, item.item_label)}
                          title="Remover item"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderAbaFechamento = () => (
    <div className="row g-4">
      <div className="col-md-6">
        <label className="form-label fw-bold">
          <i className="fas fa-calendar-alt me-2 text-primary"></i>
          Mês de Referência *
        </label>
        <select
          className="form-select form-select-lg"
          value={formData.mes_referencia}
          onChange={(e) => setFormData({ ...formData, mes_referencia: e.target.value })}
        >
          <option value="">Selecione o mês...</option>
          {gerarOpcoesMeses().map(mes => (
            <option key={mes.valor} value={mes.valor}>{mes.label}</option>
          ))}
        </select>
      </div>

      <div className="col-md-6">
        <label className="form-label fw-bold">
          <i className="fab fa-google-drive me-2" style={{ color: '#00205b' }}></i>
          Pasta do Drive do Mês *
        </label>
        <input
          type="url"
          className="form-control form-control-lg"
          value={formData.link_pasta_drive}
          onChange={(e) => setFormData({ ...formData, link_pasta_drive: e.target.value })}
          placeholder="https://drive.google.com/drive/folders/..."
        />
      </div>

      <div className="col-12">
        <div className="card border-0 shadow-sm">
          <div className="card-header bg-light d-flex justify-content-between align-items-center">
            <div>
              <i className="fas fa-tasks me-2 text-success"></i>
              <span className="fw-bold">Checklist de Documentos</span>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div className="progress" style={{ width: '150px', height: '10px' }}>
                <div 
                  className={`progress-bar ${progressoChecklist === 100 ? 'bg-success' : 'bg-primary'}`}
                  style={{ width: `${progressoChecklist}%` }}
                ></div>
              </div>
              <span className={`badge ${progressoChecklist === 100 ? 'bg-success' : 'bg-secondary'}`}>
                {getTotalMarcados()}/{totalItems}
              </span>
              <button 
                type="button" 
                className="btn btn-sm btn-outline-primary"
                onClick={marcarTodos}
                disabled={totalItems === 0}
              >
                {Object.values(checklist).every(Boolean) ? 'Desmarcar Todos' : 'Marcar Todos'}
              </button>
            </div>
          </div>
          <div className="card-body">
            {carregandoChecklist ? (
              <div className="text-center py-3">
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
                <p className="mt-2 mb-0 text-muted small">Carregando checklist...</p>
              </div>
            ) : checklistItems.length === 0 ? (
              <div className="alert border-start border-4 mb-0" style={{ borderColor: '#00205b', background: '#f7f8fa', color: '#2b2f38' }}>
                <i className="fas fa-info-circle me-2" style={{ color: '#00205b' }}></i>
                Nenhum item configurado no checklist.
                <button
                  className="btn btn-sm ms-2"
                  style={{ backgroundColor: '#00205b', borderColor: '#00205b', color: '#ffffff' }}
                  onClick={() => setAbaAtiva('configuracoes')}
                >
                  Configurar agora
                </button>
              </div>
            ) : (
              <div className="row g-3">
                {checklistItems.map((item) => (
                  <div className="col-md-6" key={item.item_key}>
                    <div 
                      className={`form-check p-3 rounded border ${checklist[item.item_key] ? 'border-success bg-success bg-opacity-10' : 'border-light bg-light'}`}
                      style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                      onClick={() => handleChecklistChange(item.item_key)}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={item.item_key}
                        checked={checklist[item.item_key] || false}
                        onChange={() => handleChecklistChange(item.item_key)}
                        style={{ width: '1.3em', height: '1.3em', cursor: 'pointer' }}
                      />
                      <label 
                        className={`form-check-label ms-2 ${checklist[item.item_key] ? 'text-success fw-bold' : ''}`}
                        htmlFor={item.item_key}
                        style={{ cursor: 'pointer' }}
                      >
                        {checklist[item.item_key] && <i className="fas fa-check me-2"></i>}
                        {item.item_label}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {getItensFaltantes().length > 0 && (
        <div className="col-12">
          <div className="alert border-start border-4 mb-0" style={{ borderColor: '#00205b', background: '#f7f8fa', color: '#2b2f38' }}>
            <i className="fas fa-exclamation-circle me-2" style={{ color: '#00205b' }}></i>
            <strong>Itens pendentes:</strong>
            <ul className="mb-0 mt-2">
              {getItensFaltantes().map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      )}

      <div className="col-12">
        <label className="form-label fw-bold">
          <i className="fas fa-exclamation-circle me-2" style={{ color: '#00205b' }}></i>
          Pendências / Observações
        </label>
        <textarea
          className="form-control posicao-obs-textarea"
          rows={4}
          value={formData.pendencias}
          onChange={(e) => setFormData({ ...formData, pendencias: e.target.value })}
          placeholder="Descreva aqui qualquer pendência ou observação importante para a contabilidade..."
        ></textarea>
        <small className="text-muted">
          Este campo será incluído no email enviado para a contabilidade
        </small>
      </div>

      {formData.mes_referencia && formData.link_pasta_drive && (
        <div className="col-12">
          <div className="card border-primary">
            <div className="card-header bg-primary text-white">
              <i className="fas fa-paper-plane me-2"></i>
              Resumo do Envio
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <p className="mb-2">
                    <strong>Mês:</strong> {gerarOpcoesMeses().find(m => m.valor === formData.mes_referencia)?.label}
                  </p>
                  <p className="mb-2">
                    <strong>Destinatário:</strong> {dadosCliente?.email_contabilidade || 'Não cadastrado'}
                  </p>
                </div>
                <div className="col-md-6">
                  <p className="mb-2">
                    <strong>Documentos concluídos:</strong> {getTotalMarcados()}/{totalItems}
                  </p>
                  <p className="mb-0">
                    <strong>Pendências:</strong> {formData.pendencias ? 'Sim' : 'Não informadas'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="col-12">
        <hr />
        <div className="d-flex justify-content-end gap-2">
          <button
            type="button"
            className="btn btn-outline-secondary btn-lg"
            onClick={() => {
              setFormData({ mes_referencia: '', link_pasta_drive: '', pendencias: '' });
              const checklistLimpo = {};
              checklistItems.forEach(item => {
                checklistLimpo[item.item_key] = false;
              });
              setChecklist(checklistLimpo);
            }}
            disabled={carregando}
          >
            <i className="fas fa-eraser me-2"></i>
            Limpar
          </button>
          <button
            type="button"
            className="btn-enviar-playful"
            onClick={abrirPreviewFechamento}
            disabled={carregando || carregandoPreview || !dadosCliente || totalItems === 0}
          >
            <span>
              {(carregando || carregandoPreview) ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  {carregandoPreview ? 'Gerando prévia...' : 'Enviando...'}
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane"></i>
                  Enviar para Contabilidade
                </>
              )}
            </span>
          </button>
        </div>
      </div>
    </div>
  );

  const renderAbaHistorico = () => (
    <div>
      {carregandoHistorico ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="mt-3 text-muted">Carregando histórico...</p>
        </div>
      ) : historico.length === 0 ? (
        <div className="text-center py-5">
          <i className="fas fa-inbox fa-4x text-muted mb-3"></i>
          <h5 className="text-muted">Nenhum fechamento enviado</h5>
          <p className="text-muted">Os fechamentos enviados aparecerão aqui.</p>
          <button 
            className="btn btn-primary mt-2"
            onClick={() => setAbaAtiva('fechamento')}
          >
            <i className="fas fa-plus me-2"></i>
            Enviar Primeiro Fechamento
          </button>
        </div>
      ) : (
        <>
          <div className="row g-3 mb-4">
            <div className="col-md-4">
              <div className="card bg-primary text-white">
                <div className="card-body text-center">
                  <h3 className="mb-0">{historico.length}</h3>
                  <small>Total de Envios</small>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card bg-success text-white">
                <div className="card-body text-center">
                  <h3 className="mb-0">
                    {historico.filter(h => h.itens_pendentes === 0).length}
                  </h3>
                  <small>Completos</small>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card bg-warning text-dark">
                <div className="card-body text-center">
                  <h3 className="mb-0">
                    {historico.filter(h => h.itens_pendentes > 0).length}
                  </h3>
                  <small>Com Pendências</small>
                </div>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th style={{ width: '140px' }}>Mês Referência</th>
                  <th style={{ width: '180px' }}>Data Envio</th>
                  <th>Documentos</th>
                  <th style={{ width: '120px' }}>Status</th>
                  <th style={{ width: '200px' }}>Enviado para</th>
                  <th style={{ width: '100px' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {historico.map((item) => {
                  const checklistObj = typeof item.checklist === 'string' 
                    ? JSON.parse(item.checklist) 
                    : item.checklist;
                  
                  return (
                    <tr key={item.id}>
                      <td>
                        <span className="badge bg-primary fs-6">
                          {formatarMesReferencia(item.mes_referencia)}
                        </span>
                      </td>
                      <td>
                        <small className="text-muted">
                          <i className="fas fa-clock me-1"></i>
                          {item.data_envio}
                        </small>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <div className="progress flex-grow-1" style={{ height: '8px', maxWidth: '150px' }}>
                            <div 
                              className={`progress-bar ${item.itens_pendentes === 0 ? 'bg-success' : 'bg-warning'}`}
                              style={{ width: `${(item.itens_concluidos / (item.itens_concluidos + item.itens_pendentes)) * 100}%` }}
                            ></div>
                          </div>
                          <small className="text-muted">
                            {item.itens_concluidos}/{item.itens_concluidos + item.itens_pendentes}
                          </small>
                        </div>
                      </td>
                      <td>
                        {item.itens_pendentes === 0 ? (
                          <span className="badge bg-success">
                            <i className="fas fa-check me-1"></i>
                            Completo
                          </span>
                        ) : (
                          <span className="badge bg-warning text-dark">
                            <i className="fas fa-exclamation me-1"></i>
                            {item.itens_pendentes} pendente(s)
                          </span>
                        )}
                      </td>
                      <td>
                        <small>{item.email_enviado_para}</small>
                      </td>
                      <td>
                        <div className="d-flex gap-1">
                          {item.link_pasta_drive && (
                            <a 
                              href={item.link_pasta_drive} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-warning"
                              title="Abrir pasta no Drive"
                            >
                              <i className="fab fa-google-drive"></i>
                            </a>
                          )}
                          <button
                            className="btn btn-sm btn-outline-info"
                            title="Ver detalhes"
                            data-bs-toggle="modal"
                            data-bs-target={`#modalDetalhe${item.id}`}
                          >
                            <i className="fas fa-eye"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {historico.map((item) => {
            const checklistObj = typeof item.checklist === 'string' 
              ? JSON.parse(item.checklist) 
              : item.checklist;
            
            return (
              <div key={`modal-${item.id}`} className="modal fade" id={`modalDetalhe${item.id}`} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                      <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                        <i className="fas fa-file-alt me-2"></i>
                        Detalhes do Fechamento - {formatarMesReferencia(item.mes_referencia)}
                      </h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label text-muted small">Mês de Referência</label>
                          <p className="fw-bold">{formatarMesReferencia(item.mes_referencia)}</p>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label text-muted small">Data de Envio</label>
                          <p className="fw-bold">{item.data_envio}</p>
                        </div>
                        <div className="col-md-12">
                          <label className="form-label text-muted small">Email Destinatário</label>
                          <p className="fw-bold">{item.email_enviado_para}</p>
                        </div>
                        <div className="col-md-12">
                          <label className="form-label text-muted small">Link da Pasta</label>
                          <p>
                            <a href={item.link_pasta_drive} target="_blank" rel="noopener noreferrer">
                              {item.link_pasta_drive}
                            </a>
                          </p>
                        </div>
                        
                        <div className="col-12">
                          <label className="form-label text-muted small">Checklist de Documentos</label>
                          <div className="list-group">
                            {checklistObj && Object.entries(checklistObj).map(([key, value]) => {
                              const itemInfo = checklistItems.find(ci => ci.item_key === key);
                              const label = itemInfo ? itemInfo.item_label : key;
                              
                              return (
                                <div key={key} className={`list-group-item d-flex justify-content-between align-items-center ${value ? 'list-group-item-success' : 'list-group-item-warning'}`}>
                                  <span>{label}</span>
                                  {value ? (
                                    <span className="badge bg-success">Concluído</span>
                                  ) : (
                                    <span className="badge bg-warning text-dark">Pendente</span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        
                        {item.pendencias && (
                          <div className="col-12">
                            <label className="form-label text-muted small">Pendências/Observações</label>
                            <div className="alert border-start border-4 mb-0" style={{ borderColor: '#00205b', background: '#f7f8fa', color: '#2b2f38', whiteSpace: 'pre-wrap' }}>
                              {item.pendencias}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                        Fechar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );

  return (
    <div className="container-fluid mt-4 fmp-brand-page">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div
            className="card border-0 shadow-sm"
          >
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center mb-2">
                    <i className="fas fa-calendar-check header-icon me-3"></i>
                    <h2 className="titulo-pagina m-0">Fechamento Mensal</h2>
                  </div>
                  <p className="mb-1 opacity-75">
                    <i className="fas fa-file-upload me-2"></i>
                    {dadosCliente ? dadosCliente.nome : 'Carregando...'}
                  </p>
                </div>
                
                <div className="d-flex gap-2">
                  {dadosCliente?.email_contabilidade && (
                    <span className="badge bg-success me-2">
                      <i className="fas fa-envelope me-1"></i>
                      {dadosCliente.email_contabilidade}
                    </span>
                  )}
                  <button
                    className="btn btn-light"
                    onClick={() => navigate(
                      dadosCliente?.sistema?.toLowerCase() === 'conta_azul'
                        ? `/dashboard-conta-azul/${cliente_id}`
                        : `/dashboard-cliente/${cliente_id}`
                    )}
                  >
                    <i className="fas fa-arrow-left me-2"></i>
                    Voltar ao Dashboard
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mensagens agora são exibidas como toast (react-toastify) */}

      {/* Abas */}
      <div className="row mb-4">
        <div className="col-12">
          <ul className="nav nav-tabs nav-fill">
            <li className="nav-item">
              <button 
                className={`nav-link ${abaAtiva === 'fechamento' ? 'active' : ''}`}
                onClick={() => setAbaAtiva('fechamento')}
                style={{
                  backgroundColor: abaAtiva === 'fechamento' ? '#00205b' : 'transparent',
                  color: abaAtiva === 'fechamento' ? '#ffffff' : '#00205b',
                  fontWeight: 600,
                  border: abaAtiva === 'fechamento' ? 'none' : '1px solid #dee2e6'
                }}
              >
                <i className="fas fa-file-upload me-2"></i>
                Novo Fechamento
              </button>
            </li>
            <li className="nav-item">
              <button 
                className={`nav-link ${abaAtiva === 'historico' ? 'active' : ''}`}
                onClick={() => setAbaAtiva('historico')}
                style={{
                  backgroundColor: abaAtiva === 'historico' ? '#00205b' : 'transparent',
                  color: abaAtiva === 'historico' ? '#ffffff' : '#00205b',
                  fontWeight: 600,
                  border: abaAtiva === 'historico' ? 'none' : '1px solid #dee2e6'
                }}
              >
                <i className="fas fa-history me-2"></i>
                Histórico de Envios
                {historico.length > 0 && (
                  <span className="badge bg-secondary ms-2">{historico.length}</span>
                )}
              </button>
            </li>
            <li className="nav-item">
              <button 
                className={`nav-link ${abaAtiva === 'configuracoes' ? 'active' : ''}`}
                onClick={() => setAbaAtiva('configuracoes')}
                style={{
                  backgroundColor: abaAtiva === 'configuracoes' ? '#00205b' : 'transparent',
                  color: abaAtiva === 'configuracoes' ? '#ffffff' : '#00205b',
                  fontWeight: 600,
                  border: abaAtiva === 'configuracoes' ? 'none' : '1px solid #dee2e6'
                }}
              >
                <i className="fas fa-cog me-2"></i>
                Gerenciar Checklist
                {checklistItems.length > 0 && (
                  <span className="badge bg-secondary ms-2">{checklistItems.length}</span>
                )}
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Conteúdo das Abas */}
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              {abaAtiva === 'fechamento' && renderAbaFechamento()}
              {abaAtiva === 'historico' && renderAbaHistorico()}
              {abaAtiva === 'configuracoes' && renderAbaConfiguracoes()}
            </div>
          </div>
        </div>
      </div>

      {/* Modal de prévia do e-mail antes de enviar */}
      {mostrarConfirmacao && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
              <div className="modal-content">
                <div className="modal-header bg-white">
                  <div>
                    <h5 className="modal-title" style={{ color: '#212529' }}>
                      <i className="fas fa-envelope-open-text me-2" style={{ color: '#00205b' }}></i>
                      Prévia do e-mail
                    </h5>
                    <small style={{ color: '#6c757d' }}>É exatamente assim que vai chegar para a contabilidade. Confirme antes de enviar.</small>
                  </div>
                  <button type="button" className="btn-close" aria-label="Fechar" onClick={() => setMostrarConfirmacao(false)}></button>
                </div>

                <div className="modal-body" style={{ background: '#f0f2f5' }}>
                  <div className="mb-3 p-3 rounded bg-white border">
                    <div className="mb-1">
                      <span className="text-muted" style={{ width: '70px', display: 'inline-block' }}>Para:</span>
                      <strong>{previewDest || '—'}</strong>
                    </div>
                    <div>
                      <span className="text-muted" style={{ width: '70px', display: 'inline-block' }}>Assunto:</span>
                      <strong>{previewAssunto || '—'}</strong>
                    </div>
                  </div>

                  {carregandoPreview ? (
                    <div className="text-center py-5">
                      <div className="spinner-border" style={{ color: '#00205b', width: '3rem', height: '3rem' }}></div>
                      <p className="mt-3 text-muted">Gerando prévia do e-mail...</p>
                    </div>
                  ) : (
                    <iframe
                      title="Prévia do e-mail"
                      srcDoc={previewHtml}
                      style={{ width: '100%', height: '65vh', border: '1px solid #e7e9ee', borderRadius: '8px', background: '#ffffff' }}
                    />
                  )}
                </div>

                <div className="modal-footer bg-white" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '14px' }}>
                  <label
                    htmlFor="confirmaInfosFechamento"
                    className="d-flex align-items-center gap-3 w-100 m-0"
                    style={{
                      background: confirmacaoMarcada ? '#e8f5ee' : '#eef2f8',
                      border: `2px solid ${confirmacaoMarcada ? '#1f9d6b' : '#00205b'}`,
                      borderRadius: '10px',
                      padding: '14px 18px',
                      cursor: (carregandoPreview || !previewHtml || carregando) ? 'not-allowed' : 'pointer',
                      transition: 'background-color .2s ease, border-color .2s ease'
                    }}
                  >
                    <input
                      className="form-check-input m-0"
                      type="checkbox"
                      id="confirmaInfosFechamento"
                      style={{ width: '22px', height: '22px', flex: 'none', cursor: 'inherit' }}
                      checked={confirmacaoMarcada}
                      disabled={carregandoPreview || !previewHtml || carregando}
                      onChange={(e) => setConfirmacaoMarcada(e.target.checked)}
                    />
                    <span style={{ fontSize: '15px', fontWeight: 600, color: confirmacaoMarcada ? '#1f7a52' : '#00205b' }}>
                      <i className={`fas ${confirmacaoMarcada ? 'fa-check-circle' : 'fa-exclamation-circle'} me-2`}></i>
                      Confirmo que revisei a prévia e as informações estão corretas
                    </span>
                  </label>

                  <div className="d-flex justify-content-end gap-2 w-100">
                    <button type="button" className="btn btn-outline-secondary" onClick={() => setMostrarConfirmacao(false)} disabled={carregando}>
                      <i className="fas fa-pen me-2"></i>Revisar
                    </button>
                    <button
                      type="button"
                      className="btn"
                      style={{ backgroundColor: '#00205b', borderColor: '#00205b', color: '#ffffff', fontWeight: 600 }}
                      onClick={enviarFechamento}
                      disabled={carregando || carregandoPreview || !previewHtml || !confirmacaoMarcada}
                    >
                      <i className={`fas ${carregando ? 'fa-spinner fa-spin' : 'fa-check'} me-2`}></i>
                      {carregando ? 'Enviando...' : 'Confirmar e Enviar'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default Fechamento_cliente;